// extracted by mini-css-extract-plugin
export default {"moduleTitle":"module-title-module--moduleTitle--69mev"};